import React, { Component } from 'react';
import Footer from './Footer';

class Header extends Component {
    render() {
      return (
        <footer>
        <div className="container">
          <div className="intro-text">
            <div className="intro-lead-in">Ti serve un sito web?</div>
            <div className="intro-heading text-uppercase">Eccomi qua</div>
            <a className="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="#services">Scopri di piu'</a>
          </div>
        </div>
        </footer>
        
      );
    }
  };
  export default Header